import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { LinearProgress, Typography, linearProgressClasses } from '@mui/material'
import { FlexColumn } from 'src/components/flex-containers'

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Shapes.spacing[6]}px;
  width: 70%;
`

const ProgressWrapper = styled(FlexColumn)`
  gap: ${Shapes.spacing[4]}px;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: `18px`,
  width: `100%`,
  borderRadius: `18px`,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: Colors.borderInputHover,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: `18px`,
    backgroundColor: Colors.blueDark,
  },
}))

type InsightDownloadLoadingProps = {
  percentage: number
}
export const InsightDownloadLoading = (props: InsightDownloadLoadingProps) => {
  const { percentage } = props
  return (
    <Wrapper>
      <Typography variant="header1" color={Colors.textBlack}>
        {percentage.toFixed(0)}%
      </Typography>
      <ProgressWrapper>
        <BorderLinearProgress variant="determinate" value={percentage} />
        <Typography variant="textmdm" color={Colors.textMedium}>
          Generating your report...
        </Typography>
      </ProgressWrapper>
    </Wrapper>
  )
}
